
export default {
    devOps: '运维',
    alert: '智能预警',
    energyIncomeAnalysis: '用能收益评估',
    incomeAnalysis: '收益评估',
    energyConsumption: '能耗分析',
    strategyOptimize: '控制策略优化',
    sparePartsManagement: '备品备件管理',
    userBehaviorAnalysis: '用户行为分析',
    opsReportAnalysis: '运维报告分析',
    configurationManagement: '项目配置管理',
    downloadData: '下载数据',
    workOrder:'工单管理',
    systemMonitor: '系统监控',
    projectFiles: '项目档案管理',
    electricityReport: '电能报告分析'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/nav.js